export default function maStringColumn() {
    return {
        restrict: 'E',
        scope: {
            value: '&'
        },
        template: '<span>{{ value() | translate }}</span>'
    };
}

maStringColumn.$inject = [];



// WEBPACK FOOTER //
// ./src/javascripts/ng-admin/Crud/column/maStringColumn.js